@if (chatHistoryList && chatHistoryList.length > 0 && !isLoadingHistory) {
    <div class="chat-history-container" (scroll)="onScroll($event)">
        @for (historyItem of displayedHistoryList; track trackByChatId($index, historyItem)) {
            <div class="chat-history-item" (click)="loadChatHistory(historyItem)">
                @if (historyItem.Title) {
                    <div class="history-item-header">
                        <span class="history-date">{{historyItem.displayDate}}</span>
                        <span class="history-title">{{historyItem.Title}}</span>
                    </div>
                }
            </div>
        }

        <!-- Loading Indicator -->
        @if (isLoading) {
            <div class="loading-indicator">
                <div class="spinner default-chat-loader">
                    <nalco-refresh-loader [isLoading]="isLoading"></nalco-refresh-loader>
                </div>
            </div>
        }

        <!-- End of List Indicator -->
        @if (!hasMoreItems && displayedHistoryList && displayedHistoryList.length > initialHistoryCount) {
            <div class="end-of-list">
                <span>{{'AI_AGENT.NO_MORE_HISTORY' | translate}}</span>
            </div>
        }
    </div>
}

@if (chatHistoryList && chatHistoryList.length === 0 && isLoadingHistory) {
    <div class="loading-indicator" style="text-align: center; padding: 10px;">
        <div class="spinner">
            <nalco-refresh-loader [isLoading]="isLoadingHistory"></nalco-refresh-loader>
        </div>
    </div>
}

<!-- No History Message -->
@if (chatHistoryList && chatHistoryList.length === 0) {
    <div class="no-history-message">
        <img src="../../../../assets/Icon-Communication.svg" class="no-history-icon" />
        <p>{{'AI_AGENT.NO_AVAILABLE_CHAT' | translate}}</p>
        <span>{{'AI_AGENT.START_NEW_CONVERSATION' | translate}}</span>
    </div>
}